import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const ContentCtx = createContext(null);

export function ContentProvider({ children }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/content");
      setContent(data);
      setError(null);
    } catch (e) {
      setError(e?.message || "Failed to load content");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (next) => {
    const payload = { site: next.site, sections: next.sections };
    const { data } = await api.put("/content", payload);
    setContent(data);
    return data;
  }, []);

  const reset = useCallback(async () => {
    const { data } = await api.post("/content/reset");
    setContent(data);
    return data;
  }, []);

  return (
    <ContentCtx.Provider value={{ content, loading, error, reload: load, save, reset, setContent }}>
      {children}
    </ContentCtx.Provider>
  );
}

export function useContent() {
  const v = useContext(ContentCtx);
  if (!v) throw new Error("useContent must be used within ContentProvider");
  return v;
}
